import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/icon/Shield-Done.png'


const _hoisted_1 = { id: "receive-item-detail" }
const _hoisted_2 = { class: "flex items-start sm:items-center flex-col sm:flex-row justify-between mb-3" }
const _hoisted_3 = { class: "mr-3 font-bold mb-3 sm:mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-start mb-2 space-x-2 w-full ml-auto sm:hidden"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Copy ")
const _hoisted_6 = { class: "font-bold text-xs md:text-base lg:text-base" }
const _hoisted_7 = {
  key: 0,
  class: "sm:flex items-center space-x-2 hidden mr-2"
}
const _hoisted_8 = { class: "font-bold text-xs md:text-base lg:text-base" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Copy ")
const _hoisted_10 = { class: "flex gap-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "text-white text-xs md:text-sm lg:text-sm" }, "Tampil Kode Unik", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "pi pi-print" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "flex items-center space-x-2"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "text-white mr-1 lg:mr-2 md:mr-2 text-xs md:text-sm lg:text-sm" }, "Diterima Agen", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  class: "w-5 h-5",
  style: {"-ms-transform":"rotate(180deg)","-webkit-transform":"rotate(180deg)","transform":"rotate(180deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "#ffffff",
    d: "M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23a1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z"
  })
], -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "text-white mr-1 lg:mr-2 md:mr-2 text-xs md:text-sm lg:text-sm" }, "Serah Terima Barang", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  class: "w-5 h-5",
  style: {"-ms-transform":"rotate(180deg)","-webkit-transform":"rotate(180deg)","transform":"rotate(180deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "#ffffff",
    d: "M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23a1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z"
  })
], -1)
const _hoisted_20 = { class: "flex flex-wrap md:flex-nowrap items-center md:justify-between" }
const _hoisted_21 = { class: "flex w-full lg:items-center md:items-start lg:w-auto mb-3 md:mb-0 lg:mb-0 md:w-3/5" }
const _hoisted_22 = { class: "color-blue-grey font-bold lg:mr-2 md:mr-2 sm:mr-1 text-base" }
const _hoisted_23 = {
  key: 0,
  class: "grey-bg-border px-2 rounded-md text-sm self-start"
}
const _hoisted_24 = { class: "flex md:justify-end items-center w-full mt-2 md:mt-0 md:w-2/5" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "mr-2 text-base font-normal" }, "Status :", -1)
const _hoisted_26 = {
  key: 0,
  class: "flex flex-col items-start  md:items-start mt-3 md:mt-0 lg:mt-0 "
}
const _hoisted_27 = { class: "color-blue-grey font-bold lg:mr-2 md:mr-2 text-base" }
const _hoisted_28 = { class: "color-blue-grey font-bold lg:mr-2 md:mr-2 text-base" }
const _hoisted_29 = { class: "color-blue-grey font-bold lg:mr-2 md:mr-2 text-base" }
const _hoisted_30 = { class: "grid gap-4 grid-cols-1 sm:grid-cols-2 mb-4" }
const _hoisted_31 = { class: "background-blue-grey-lighten-5 rounded-lg px-5 py-3" }
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-base mb-4" }, "Detail Data Pengirim:", -1)
const _hoisted_33 = { class: "mb-2" }
const _hoisted_34 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Nama Pengirim / Perusahaan", -1)
const _hoisted_35 = { class: "mb-2" }
const _hoisted_36 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "No Telepon", -1)
const _hoisted_37 = { class: "mb-2" }
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Alamat Pengirim / Perusahaan", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Catatan Alamat"),
  /*#__PURE__*/_createVNode("p")
], -1)
const _hoisted_40 = { class: "background-blue-grey-lighten-5 rounded-lg px-5 py-3" }
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-base mb-4" }, "Detail Data Penerima:", -1)
const _hoisted_42 = { class: "mb-2" }
const _hoisted_43 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Nama Penerima / Perusahaan", -1)
const _hoisted_44 = { class: "mb-2" }
const _hoisted_45 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "No Telepon", -1)
const _hoisted_46 = { class: "mb-2" }
const _hoisted_47 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Alamat Penerima / Perusahaan", -1)
const _hoisted_48 = { class: "mb-2" }
const _hoisted_49 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Catatan Alamat", -1)
const _hoisted_50 = { class: "grid gap-4 grid-cols-1 sm:grid-cols-2 mb-4 background-blue-grey-lighten-5" }
const _hoisted_51 = { class: " rounded-lg px-5 py-3" }
const _hoisted_52 = { class: "flex font-bold text-base mb-4" }
const _hoisted_53 = /*#__PURE__*/_createVNode("img", {
  alt: "total pendapatan",
  src: _imports_0,
  class: "lg:w-6 md:w-6 w-3 mr-3"
}, null, -1)
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Asuransi ")
const _hoisted_55 = { class: "color-blue-grey ml-1" }
const _hoisted_56 = { class: "flex" }
const _hoisted_57 = { class: "mb-2 flex-auto" }
const _hoisted_58 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Harga Barang", -1)
const _hoisted_59 = { class: "mb-2 flex-auto" }
const _hoisted_60 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "No Asuransi", -1)
const _hoisted_61 = { class: " rounded-lg px-5 py-3 border-l-2 border-dashed border-gray-400" }
const _hoisted_62 = { class: "flex" }
const _hoisted_63 = { class: "mb-2 flex-auto" }
const _hoisted_64 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Ket. Pengakuan Barang", -1)
const _hoisted_65 = { class: "mb-4 flex items-center" }
const _hoisted_66 = /*#__PURE__*/_createVNode("p", { class: "mr-2 flex-none" }, "Label : ", -1)
const _hoisted_67 = { class: "flex-grow flex items-center overflow-x-auto py-2 small-scroll-x" }
const _hoisted_68 = {
  key: 0,
  class: "grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
}
const _hoisted_69 = { class: "delivery-photo mb-4" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createVNode("p", { class: "" }, "Bukti Penerimaan :"),
  /*#__PURE__*/_createVNode("p", {
    class: "",
    style: {"font-size":"12px","color":"red"}
  }, [
    /*#__PURE__*/_createVNode("em", null, "*klik gambar untuk lihat lebih jelas")
  ])
], -1)
const _hoisted_71 = { class: "data-delivery mb-4" }
const _hoisted_72 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, "Diterima Oleh :", -1)
const _hoisted_73 = { class: "flex items-center text-sm mb-1" }
const _hoisted_74 = { class: "mr-2" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { class: "text-sm mb-1" }
const _hoisted_77 = { class: "text-sm" }
const _hoisted_78 = { class: "flex items-center px-4 pt-4 pb-2 justify-between" }
const _hoisted_79 = /*#__PURE__*/_createVNode("p", { class: "text-base font-normal" }, "Daftar Barang Akan Dikirim", -1)
const _hoisted_80 = { class: "text-base font-normal" }
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Total ")
const _hoisted_82 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_83 = { class: "mr-1" }
const _hoisted_84 = { class: "text-black font-semibold px-4 h-14 flex items-center" }
const _hoisted_85 = { class: "text-black font-semibold px-4 h-14 flex items-center" }
const _hoisted_86 = { class: "p-5" }
const _hoisted_87 = /*#__PURE__*/_createVNode("p", { class: "text-center color-blue-grey" }, "Data Tidak Ditemukan", -1)
const _hoisted_88 = {
  class: "flex w-full justify-between items-center pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_89 = /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "Serah Terima Barang", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Lightgallery = _resolveComponent("Lightgallery")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_HjexTimeline = _resolveComponent("HjexTimeline")
  const _component_ReceiveItemForm = _resolveComponent("ReceiveItemForm")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_clipboard = _resolveDirective("clipboard")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (_ctx.data)
      ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
          title: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", {
                class: `flex flex-col items-start ${_ctx.showGuid ? 'w-full sm:w-auto' : ''}`
              }, [
                _createVNode("h5", _hoisted_3, "#" + _toDisplayString(_ctx.data.Resi), 1),
                (_ctx.showGuid)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _withDirectives(_createVNode(_component_Button, { class: "grey-bg-border px-3 py-1 rounded-md text-sm btn-secondary" }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 512), [
                        [_directive_clipboard, _ctx.data.Guid, "copy"],
                        [_directive_clipboard, _ctx.successCopy, "success"],
                        [_directive_clipboard, _ctx.errorCopy, "error"]
                      ]),
                      _createVNode("p", _hoisted_6, _toDisplayString(_ctx.data.Guid), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode("div", {
                class: ["flex items-center", !_ctx.showGuid ? 'space-x-2' : 'space-x-0']
              }, [
                (_ctx.showGuid)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("p", _hoisted_8, _toDisplayString(_ctx.data.Guid), 1),
                      _withDirectives(_createVNode(_component_Button, { class: "grey-bg-border px-3 py-1 rounded-md text-sm btn-secondary" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }, 512), [
                        [_directive_clipboard, _ctx.data.Guid, "copy"],
                        [_directive_clipboard, _ctx.successCopy, "success"],
                        [_directive_clipboard, _ctx.errorCopy, "error"]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_10, [
                  (_ctx.accessGuid && !_ctx.showGuid)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-sm font-semibold rounded-lg btn-primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showingGuid()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.canPrint && !_ctx.cannotPrintStatus.includes(_ctx.data.StatusPengirimanId))
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        class: "font-semibold btn-primary",
                        onClick: _ctx.printResi
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isFromGuid)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      (_ctx.data.StatusPengirimanId === 4 && _ctx.route.meta.permission?.write && _ctx.toAgentId == _ctx.data.AgenTujuanId)
                        ? (_openBlock(), _createBlock("div", _hoisted_14, [
                            _createVNode(_component_Button, {
                              class: "p-button-sm font-semibold rounded-lg p-button-secondary",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitDropAgent()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_15,
                                _hoisted_16
                              ]),
                              _: 1
                            })
                          ]))
                        : (_ctx.data.StatusPengirimanId === 5 && _ctx.route.meta.permission.write && _ctx.toAgentId == _ctx.data.AgenTujuanId)
                          ? (_openBlock(), _createBlock("div", _hoisted_17, [
                              _createVNode(_component_Button, {
                                class: "p-button-sm font-semibold rounded-lg btn-primary",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showForm()))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_18,
                                  _hoisted_19
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("p", _hoisted_22, "(" + _toDisplayString(_ctx.data?.AgenAsalKode) + ") " + _toDisplayString(_ctx.data.AgenAsalNama) + " - (" + _toDisplayString(_ctx.data.AgenTujuanKode) + ") " + _toDisplayString(_ctx.data.AgenTujuanNama), 1),
                (_ctx.toAgentId == _ctx.data.AgenTujuanId)
                  ? (_openBlock(), _createBlock("p", _hoisted_23, "You"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode("p", {
                  class: "grey-bg-border px-2 rounded-md font-normal text-base",
                  style: { background: `${_ctx.data.StatusPengirimanAttribute1 ?? '#eceff1'}`, border: `2px solid ${_ctx.data.StatusPengirimanAttribute2 ?? '#546e7a'}`, color: _ctx.data.StatusPengirimanAttribute2 ?? '#546e7a' }
                }, _toDisplayString(_ctx.data.StatusPengirimanStatus), 5)
              ])
            ]),
            (_ctx.data.TransJadwalHdKodeJadwal)
              ? (_openBlock(), _createBlock("div", _hoisted_26, [
                  _createVNode("p", _hoisted_27, _toDisplayString(_ctx.data.TipePengiriman), 1),
                  _createVNode("p", _hoisted_28, _toDisplayString(_ctx.data.TransJadwalHdKodeJadwal), 1),
                  _createVNode("p", _hoisted_29, "Tanggal Berangkat : " + _toDisplayString(_ctx.moment(_ctx.data.TransJadwalHdTanggalAktif).format('DD MMM YYYY')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          content: _withCtx(() => [
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode("p", null, _toDisplayString(_ctx.data.NamaPengirim), 1)
                ]),
                _createVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode("p", null, _toDisplayString(_ctx.data.HpPengirim), 1)
                ]),
                _createVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode("p", null, _toDisplayString(_ctx.data.AlamatPengirim), 1)
                ]),
                _hoisted_39
              ]),
              _createVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode("p", null, _toDisplayString(_ctx.data.NamaPenerima), 1)
                ]),
                _createVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode("p", null, _toDisplayString(_ctx.data.HpPenerima), 1)
                ]),
                _createVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createVNode("p", null, _toDisplayString(_ctx.data.AlamatPenerima), 1)
                ]),
                _createVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createVNode("p", null, _toDisplayString(_ctx.data.KeteranganPenerima), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_50, [
              _createVNode("div", _hoisted_51, [
                _createVNode("p", _hoisted_52, [
                  _hoisted_53,
                  _hoisted_54,
                  _createVNode("span", _hoisted_55, _toDisplayString(_ctx.dataAnsuransi.nama ?? '-'), 1)
                ]),
                _createVNode("div", _hoisted_56, [
                  _createVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createVNode("p", null, "Rp. " + _toDisplayString(new Number(_ctx.data?.PengakuanNilaiBarang ?? 0).toLocaleString("id-ID")), 1)
                  ]),
                  _createVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode("p", null, _toDisplayString(_ctx.dataAnsuransi.hasAnsuransi? (_ctx.data.NoReferensiAsuransi??'Menunggu Proses Asuransi'): ''), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_61, [
                _createVNode("div", _hoisted_62, [
                  _createVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode("p", null, _toDisplayString(_ctx.data.KeteranganBiayaTambahan ?? '-'), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_65, [
              _hoisted_66,
              _createVNode("div", _hoisted_67, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.usedLabels, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: 'label-' + index,
                    class: "label-ticket font-bold text-sm mr-2",
                    style: { background: item.Color, color: _ctx.$textColorFromHex(item.Color) }
                  }, _toDisplayString(item.Code), 5))
                }), 128))
              ])
            ]),
            (_ctx.deliveryRecipient)
              ? (_openBlock(), _createBlock("div", _hoisted_68, [
                  _createVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createVNode(_component_Lightgallery, {
                      images: _ctx.deliveryRecipient?.Images,
                      class: "flex flex-wrap space-x-2"
                    }, null, 8, ["images"])
                  ]),
                  _createVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _createVNode("div", null, [
                      _createVNode("p", _hoisted_73, [
                        _createVNode("b", _hoisted_74, _toDisplayString(_ctx.deliveryRecipient.Recipient), 1),
                        (_ctx.deliveryRecipient.RecipientPhoneNumber)
                          ? (_openBlock(), _createBlock("span", _hoisted_75, "(" + _toDisplayString(_ctx.deliveryRecipient.RecipientPhoneNumber) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("p", _hoisted_76, "KTP : " + _toDisplayString(_ctx.deliveryRecipient.RecipientIdNumber), 1),
                      _createVNode("p", _hoisted_77, _toDisplayString(_ctx.moment(_ctx.deliveryRecipient.CreatedAt).format('DD MMM YYYY')) + " (" + _toDisplayString(_ctx.moment(_ctx.deliveryRecipient.CreatedAt).format('HH:mm')) + ")", 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TabView, {
              class: "color-primary mb-5",
              activeIndex: _ctx.currentTab,
              "onUpdate:activeIndex": _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentTab = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TabPanel, { header: "Daftar Barang" }),
                _createVNode(_component_TabPanel, { header: "Log Status Pengiriman" })
              ]),
              _: 1
            }, 8, ["activeIndex"]),
            (_ctx.currentTab === 0)
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 1,
                  class: "card-no-shadow card-p-0 mb-8"
                }, {
                  title: _withCtx(() => [
                    _createVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createVNode("p", _hoisted_80, [
                        _hoisted_81,
                        _createVNode("b", null, _toDisplayString(_ctx.data?.TransPengirimanDetails.length) + " Barang", 1)
                      ])
                    ])
                  ]),
                  content: _withCtx(() => [
                    _createVNode(_component_DataTable, {
                      value: _ctx.data.TransPengirimanDetails,
                      class: "table-og body-td-x-0",
                      responsiveLayout: "scroll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, { header: "Satuan" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode("div", _hoisted_82, [
                              _createVNode("p", _hoisted_83, _toDisplayString(slotProps.data.Berat), 1),
                              _createVNode("span", null, _toDisplayString(slotProps.data.KategoriBarangSatuanKode), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, { header: "Kategori Barang" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode("p", _hoisted_84, _toDisplayString(slotProps.data.KategoriBarangNama), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_Column, { header: "Keterangan Barang" }, {
                          body: _withCtx((slotProps) => [
                            _createVNode("p", _hoisted_85, _toDisplayString(slotProps.data.Keterangan), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }))
              : (_ctx.currentTab === 1)
                ? (_openBlock(), _createBlock(_component_Card, {
                    key: 2,
                    class: "card-no-shadow card-p-0 mb-8"
                  }, {
                    content: _withCtx(() => [
                      _createVNode("div", _hoisted_86, [
                        _createVNode(_component_HjexTimeline, { logs: _ctx.deliveryStatusLogs }, null, 8, ["logs"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_Card, { key: 1 }, {
          content: _withCtx(() => [
            _hoisted_87
          ]),
          _: 1
        })),
    _createVNode(_component_Dialog, {
      class: "dialog-confirm",
      visible: _ctx.dialogForm,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogForm = $event)),
      dismissableMask: true,
      modal: true,
      onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hideForm()))
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_88, [
          _hoisted_89,
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideForm()))
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ReceiveItemForm, {
          id: _ctx.data?.Id,
          onSuccessBack: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getAllData())),
          onHideForm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hideForm()))
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}